export const TRANSPORTERS_RESET_STATE = 'TRANSPORTERS_RESET_STATE';
export const TRANSPORTERS_CURRENT_ITEM = 'TRANSPORTERS_CURRENT_ITEM';

export const TRANSPORTERS_REQUEST_LOADING = 'TRANSPORTERS_REQUEST_LOADING';
export const TRANSPORTERS_REQUEST_SUCCESS = 'TRANSPORTERS_REQUEST_SUCCESS';
export const TRANSPORTERS_REQUEST_FAILED = 'TRANSPORTERS_REQUEST_FAILED';

export const TRANSPORTERS_CURRENT_ACTION = 'TRANSPORTERS_CURRENT_ACTION';
export const TRANSPORTERS_RESET_ACTION = 'TRANSPORTERS_RESET_ACTION';